import * as React from "react";
const SvgFiBrandsMicrosoftExplorer = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-microsoft-explorer_svg__a)">
      <path
        fill="#151A2D"
        d="M23.993 12.598c-.027-1.91-.494-3.707-1.348-5.28C26.352-.995 18.867.125 18.265.24c-1.574.315-3.147.82-4.495 1.46-5.168-.06-9.662 2.697-11.122 8.427 2.696-3.033 4.606-4.269 5.73-4.718-.237.213-.473.437-.709.662-1.797 1.797-3.258 3.595-4.494 5.505-.955 1.685-2.022 3.146-2.584 5.055-3.033 11.01 6.516 6.404 7.864 5.617 1.46.72 3.033 1.112 4.831 1.112 4.718 0 8.763-3.033 10.223-7.19h-5.73c-2.696 4.27-9.1 2.36-9.325-2.247h15.503c.061-.46.041-.993.036-1.325M22.364 6.87c-1.236-2.022-3.033-3.595-5.28-4.38 1-.484 3.558-1.458 4.943-.563 1.04.672 1.491 1.99.337 4.943M2.086 22.26c-.794-.72-.899-2.696.786-6.179a10.64 10.64 0 0 0 4.718 5.73c-1.089.595-3.977 1.836-5.504.45m6.291-11.235c.087-2.472 2.247-4.494 4.943-4.494s4.831 2.022 4.943 4.494z"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-microsoft-explorer_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsMicrosoftExplorer;
